import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import * as reducers from "./reducers";
import { logger } from 'redux-logger';
import throttle from 'lodash/throttle';
import { loadState, saveState } from './localStorage';
import createSagaMiddleware from 'redux-saga';
import rootSagas from './sagas';

const persistedState = loadState();
const appReducer = combineReducers(reducers);
const sagaMiddleware = createSagaMiddleware()

const rootReducer = (state, action) => {
    if (action.type === 'RESET') {
        state = undefined;
    }
    return appReducer(state, action)
}

const middleware = applyMiddleware(
    thunkMiddleware,
    logger,
    sagaMiddleware
);

const store = createStore(
    rootReducer,
    persistedState,
    middleware
);
export default function configureStore() {


    store.subscribe(throttle(() => {
        saveState(store.getState());
    }), 1000);

    sagaMiddleware.run(rootSagas)

    return store;
};
